import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [notices, setNotices] = useState([]);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const [s, n] = await Promise.all([
        api.get("/site-settings"),
        api.get("/notices/active").catch(() => ({ data: [] })),
      ]);
      setSettings(s.data || {});
      setNotices(n.data || []);
    } catch { /* ignore */ }
    finally { setReady(true); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    const on = !!settings.promo_enabled && !!settings.promo_text;
    document.documentElement.style.setProperty("--pg-promo-h", on ? "36px" : "0px");
  }, [settings.promo_enabled, settings.promo_text]);

  return <Ctx.Provider value={{ settings, notices, ready, refresh, setSettings }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx) || { settings: {}, notices: [], ready: false, refresh: () => {} };
